export default __webpack_public_path__ + "static/media/undraw_winners.009ff638.svg";